import { useQuery } from "@tanstack/react-query";
import { Intent, SimpleIntent } from "@/model";
import intentRepository from "@/repository/intentRepository";
import { intentQueryKeys } from "./keys";


const getData = async (agentId: number) => {
    const res = await intentRepository.getNames(agentId);
    if (!res.data?.data) {
        return [];
    }
    const intents = res.data?.data as Intent[];
    return intents.map(intent => ({
        name: intent.name,
        id: intent.id,
        active: intent.active
    }));
};

export const useIntentNames = (agentId: number) => {
    return useQuery<SimpleIntent[]>({
        queryKey: intentQueryKeys.names(agentId),
        queryFn: async () => getData(agentId),
        retry: false
    });
};
